import { combineReducers } from "redux";
import globalErrorSlice from "./globalError.slice";
import globalSlice from "./global.slice";
import mapsSlice from "./maps.slice";

const rootReducer = combineReducers({
  globalErrorSlice,
  globalSlice,
  mapsSlice,
});

export default rootReducer;
